import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState,useEffect } from "react";
import axios from "axios";
export default function TeamDetails() {
    const { t,i18n } = useTranslation();
    useScrollAnimation();

    const { id } = useParams();

    const [dataMember, setDataMember] = useState([]);
    const member = dataMember.find(item => item.id.toString() === id);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.alnujoud-jo.com/api/members");
                setDataMember(response.data.data);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };
    if (!member) {
        return <div className="text-center text-red-500">{t("Member not found")}</div>;
    }
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Member Details")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("Member Details")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-center gap-[7px]">
                        <img className="" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Member Details")}</div>
                    </div>
                    <div className="f-col p-5 border shadow-lg rounded-lg flex justify-between">
                        <div className="w-100 w-[49%]">
                            <img className="w-[100%] h-[100%] object-cover rounded-[8px]" src={member.image} alt={member.name} />
                        </div>
                        <div className="w-100 w-[49%] flex flex-col gap-[25px]">
                            <div className="">
                                <div className="font-bold text-[#017E89] text-[20px] capitalize mt-3">
                                    {t(getLocalizedText({ A: member.name_ar, E: member.name_en }))}
                                </div>
                                <div className="capitalize">
                                    {t(getLocalizedText({ A: member.job_title_ar, E: member.job_title_en }))}
                                </div>
                            </div>
                            <div className="flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("Speciality")}</div>
                                <div className="capitalize">
                                    {t(getLocalizedText({ A: member.specialization_ar, E: member.specialization_en }))}
                                </div>
                            </div>
                            <div className="flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("Degrees")}</div>
                                <div className="capitalize">
                                    {t(getLocalizedText({ A: member.degree_ar, E: member.degree_en }))}
                                </div>
                            </div>
                            <div className="f-col flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("experience")}</div>
                                <div className="capitalize">
                                    {t(getLocalizedText({ A: member.experience_ar, E: member.experience_en }))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
